import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { map, filter, takeUntil } from 'rxjs/operators';

import 'moment/locale/it';

import { environment } from '../../../environments/environment';
import {
  AlgConsensoService
} from '../../services/alg-consenso.service';

@Component({
  selector: 'alg-switch-page',
  templateUrl: './alg-switch-page.component.html',
  styleUrls: ['./alg-switch-page.component.scss']
})
export class AlgSwitchPageComponent implements OnInit, OnDestroy {

  private opportunityId$: Observable<any>;
  private ngUnsubscribe = new Subject<void>();
  public isError = false;
  public actType = '';

  constructor(
    private route: ActivatedRoute,
    private api: AlgConsensoService,
    private router: Router
  ) {

    this.opportunityId$ = this.route.params
      .pipe(
        map(params => params && params.id)
      );

  }

  ngOnInit() {
    //check if opportunity id is not empty and is set
    this.opportunityId$
      .pipe(
        filter(id => typeof id !== 'string' || typeof id === 'string' && id.trim() === ''),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((id) => {
        window.location.href = environment.websiteUrl;
      });

    //get opportunity from backend
    this.opportunityId$
      .pipe(
        filter(id => typeof id === 'string' && id.trim() !== ''),
        takeUntil(this.ngUnsubscribe)
      )
      .subscribe((id) => {
        this.api.checkOpportunity(id).subscribe(resp => {
          if(resp.status != 200) {
            this.isError = true;
          }else{
            this.actType = resp.result.actType;
          }
        })
      });

  }

  public ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/alg-switch-page/alg-switch-page.component.ts